import {Box, Text} from '@mantine/core';
import type {FC, ReactNode} from 'react';

/**
 * Read-only label/value pair (`ViewField`) and label/boolean pair
 * (`ViewSwitch`) for detail/view pages.
 * @registry Label-over-value display for read-only detail fields.
 *
 * Ported from `library-m/data-display/ViewField`. Prop surface and exports
 * kept identical.
 */
export interface ViewFieldProps {
  label: string;
  value: ReactNode;
  description?: string;
  'data-testid'?: string;
}

export const ViewField: FC<ViewFieldProps> = ({
  label,
  value,
  description,
  ...rest
}) => (
  <Box data-testid={rest['data-testid']}>
    <Text fw={500} size="sm" c="dimmed">
      {label}
    </Text>
    {description && (
      <Text size="xs" c="dimmed">
        {description}
      </Text>
    )}
    <Text size="md">{value || '—'}</Text>
  </Box>
);

export interface ViewSwitchProps {
  label: string;
  value: boolean;
  'data-testid'?: string;
}

export const ViewSwitch: FC<ViewSwitchProps> = ({label, value, ...rest}) => (
  <Box data-testid={rest['data-testid']}>
    <Text fw={500} size="sm" c="dimmed">
      {label}
    </Text>
    <Text size="md" c={value ? 'green' : 'dimmed'}>
      {value ? 'Yes' : 'No'}
    </Text>
  </Box>
);
